import {createApp} from 'vue';
import App from './app/app.vue';
import router from './router';
import store from './store/store';

import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome';
import {library} from '@fortawesome/fontawesome-svg-core';
import { fas } from "@fortawesome/free-solid-svg-icons";
import {fab} from '@fortawesome/free-brands-svg-icons';

import Toast, {PluginOptions} from 'vue-toastification';
import {VueWindowSizePlugin} from 'vue-window-size/option-api';

import '@progress/kendo-theme-bootstrap/dist/all.css';
import './index.scss';
import {i18n} from '@/utils/i18n';

library.add(fas, fab);

const options: PluginOptions = {
  timeout: 5000,
  closeOnClick: true,
  pauseOnFocusLoss: true,
  pauseOnHover: true,
  draggable: true,
  draggablePercent: 0.6,
  showCloseButtonOnHover: false,
  hideProgressBar: false,
  closeButton: 'button',
  icon: true,
  rtl: false
};

createApp(App)
  .component('font-awesome-icon', FontAwesomeIcon)
  .use(store)
  .use(router)
  .use(VueWindowSizePlugin)
  .use(Toast, options)
  .use(i18n)
  .mount('#app');
